import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui';
import { BROWSE_HREF } from '../browse/facets';

export interface HeroContentProps {
  bhajanOfDayHref?: string;
}

export const HeroContent: React.FC<HeroContentProps> = ({ bhajanOfDayHref = '/bhajans' }) => (
  <div className="hero__content">
    <h1>Bhajan Mala</h1>
    <p className="hero__subhead">
      All of Sri Swamiji's Bhajans (and popular Stotras/Mantras) in one place.
    </p>
    <div className="hero__ctas">
      {/*
        The CTA is labelled "Browse", so it goes to the browse hub — it pointed
        at /bhajans, the flat list. BROWSE_HREF rather than a literal /browse:
        that route only mounts for an app that declares facet hubs, and a
        zero-facet tenant has to fall back to the flat list.
      */}
      <Link to={BROWSE_HREF}>
        <Button variant="primary" size="lg">Browse</Button>
      </Link>
      <Link to={bhajanOfDayHref}>
        <Button variant="secondary" size="lg">Bhajan of the Day</Button>
      </Link>
    </div>
  </div>
);
